import React, { useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Box, 
    Button, 
    CircularProgress, 
    Dialog, 
    DialogContent, 
    DialogActions 
} from '@mui/material';
import { useSelector } from 'react-redux';

import CropImg from 'Assets/Images/CropIcon.svg';
import rotateLeft from 'Assets/Images/RotateLeft.svg';

const ImageCrop = ({ isOpen, imageToCrop, isApiCalling, setCroppedImage, setBase64Image, cancelCropImage, onSubmitCroppedImage }) => {
  const [crop, setCrop] = useState({});
  const [image, setImage] = useState(null);
  const [isCrop, setIsCrop] = useState(false);
  const [isDisabaled, setIsDisabled] = useState(true);
  const [rotate, setRotate] = useState(0);

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  const onCropHandler = () => {
    setIsCrop(true);
    setIsDisabled(false);
  };

  const cropImageDone = () => {
    setIsCrop(false);
    setIsDisabled(true);
    if (!crop.width || !crop.height || !image) {
      return;
    }

    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight
    );

    canvas.toBlob((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      setCroppedImage(objectUrl);

      const reader = new FileReader();
      reader.onloadend = async () => {
      const imageDataUrl = reader.result; // data:image/jpeg;base64,...
      console.log('imageDataUrl: ', imageDataUrl);
      const base64Image = imageDataUrl.split(',')[1]; // Strip off the data URL prefix
      setBase64Image(base64Image);
    };

    reader.readAsDataURL(blob);

    }, 'image/jpeg');
    setCrop({});
  };


  const handleRotate = () => {
    let angle;
    setRotate((prev) => {
      angle = prev + 90;
      return parseInt((prev + 90) / 180);
    });
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (angle % 180 === 0) {
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
    } else {
      canvas.width = image.naturalHeight;
      canvas.height = image.naturalWidth;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((angle * Math.PI) / 180);
    ctx.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);

    canvas.toBlob((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      setCroppedImage(objectUrl);
    }, 'image/jpeg');
  };

  const handleCancel = () => {
    setCrop({});
    setImage(null);
    setRotate(0);
    setIsCrop(false);
    setIsDisabled(true);
    cancelCropImage();
  };

  const handleSubmit = () => {
    onSubmitCroppedImage();
  };

  return (
    <Dialog
      open={isOpen}
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className='rcDialog'
    >
      <DialogContent>
        {!isCrop && !isApiCalling && imageToCrop && <Box className="rotateCrop" sx={{ display: 'flex', justifyContent: 'center', gap: 2, pb: 3 }}>
          <Button
            variant="contained"
            sx={{ mt: 0, mb: 0, pt: 0.5, pb: 0.5, px: 2, fontSize: '18px', textTransform: 'none' }}
            size="small"
            className="cis-btn btn-gray m-0"
            onClick={onCropHandler}
          >
            <img src={CropImg} />
          </Button>
          <Button
            variant="contained"
            sx={{ mt: 0, mb: 0, pt: 0.5, pb: 0.5, px: 2, fontSize: '18px', textTransform: 'none' }}
            size="small"
            className="cis-btn btn-gray m-0"
            onClick={handleRotate}
          >
            <img src={rotateLeft} />
          </Button>
        </Box>}

        {imageToCrop && !isApiCalling &&
          <Box display={"flex"} justifyContent={"center"}>
            <ReactCrop
              src={imageToCrop}
              onImageLoaded={(img) => setImage(img)}
              crop={crop}
              onChange={(newCrop) => setCrop(newCrop)}
              disabled={isDisabaled}
            />
          </Box>
        }

        { isApiCalling && 
          <Box display={"flex"} justifyContent={"center"} minWidth="60px">
            <CircularProgress />
          </Box> }
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3 }}>

        <Button
          variant="contained"
          sx={{ mt: 0, mb: 0, pt: 0.5, pb: 0.5, px: 2, width: '120px', fontSize: '18px', textTransform: "none" }}
          size="small"
          className='cis-btn m-0'
          onClick={handleCancel}
        >
          {Translation?.Cancel}
        </Button>

        {isCrop ?
          <Button
            variant="contained"
            sx={{ mt: 0, mb: 0, pt: 0.5, pb: 0.5, px: 2, width: '120px', fontSize: '18px', textTransform: "none" }}
            size="small"
            className='cis-btn m-0'
            onClick={cropImageDone}
          >
            {Translation?.Done}
          </Button> :
          <Button
            variant="contained"
            disabled={isApiCalling}
            sx={{ mt: 0, mb: 0, pt: 0.5, pb: 0.5, px: 2, width: '120px', fontSize: '18px', textTransform: "none" }}
            size="small"
            className='cis-btn m-0'
            onClick={handleSubmit}
          >
            {Translation?.Submit}
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ImageCrop);